var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemovePersonWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6157_39929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6157_39929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77862 9.70265C8.76883 10.91 8.24613 12.2896 8.21439 13.8726H1.00855C0.897144 12.287 1.87649 10.1813 3.82158 9.1359C5.72198 8.11445 8.28175 8.34439 9.77862 9.70265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41472 3.98406C3.38104 2.43343 4.65121 1.00845 6.41364 1.00003C8.04783 0.99226 9.40414 2.38679 9.3886 4.02422C9.37305 5.66682 8.03746 6.98298 6.38903 6.98039C4.71727 6.9778 3.4063 5.65711 3.41536 3.98471L3.41472 3.98406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.705,
    cy: 13.705,
    r: 4.955,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75H16.25",
    stroke: "#ED705B",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePersonWhite);
export default __webpack_public_path__ + "static/media/remove_person_white.8eb0f63673262fa7f91f616bcc15959c.svg";
export { ForwardRef as ReactComponent };